import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

class VTPipingReportSummary extends Form {
	state = {
		data: { summary: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		summary: Joi.string().min(10).required().label('Summary'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.summary);
		this.setState({ data: { summary: '' } });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'summary',
							placeholder: 'Enter Report Summary',
							label: 'Summary',
							rows: '6',
						})}
					</div>
				</div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default VTPipingReportSummary;
